import { PtcldScriptContextProvider, usePtcldScriptContext } from "contexts/PtcldScriptContext";

import PointCloudViewerContent from "containers/PointCloudViewer/components/PointCloudViewerContent";

export default function PointCloudViewer() {
  return (
    <PtcldScriptContextProvider>
      <PointCloudViewerContent />
    </PtcldScriptContextProvider>
  );
}
